// Decimal-safe first-sentence splitter. Splits only on sentence-ending
// punctuation followed by whitespace and a capital letter, so numerics like
// "pH 5.8" or "0.5 ppm" stay intact in the lede.
//
// Deliberately avoids regex lookbehind/lookahead. Older Safari/iOS
// JavaScriptCore rejects lookbehind at parse time with
// "SyntaxError: Invalid regular expression: invalid group specifier name",
// which crashed the whole consuming component on module load. Instead we
// *consume* the boundary: the match captures "<punct><whitespace><capital>",
// then we slice around it.
const SENTENCE_BOUNDARY = /[.!?]\s+[A-Z]/

export interface LedeSplit {
  lede: string
  rest: string
}

export function splitLede(text: string): LedeSplit {
  if (!text) return { lede: '', rest: '' }
  const trimmed = text.trim()
  const match = SENTENCE_BOUNDARY.exec(trimmed)
  if (!match) return { lede: trimmed, rest: '' }
  // match.index points at the sentence-ending punctuation; the lede ends just
  // after it. The trailing capital is the last char of the match, where `rest`
  // begins.
  const restStart = match.index + match[0].length - 1
  return {
    lede: trimmed.slice(0, match.index + 1).trim(),
    rest: trimmed.slice(restStart).trim(),
  }
}
